import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  StyledCustomStoryActions,
} from "../styled/details/stylesDetails";
import {
  FaUnlock,
  FaLock,
  FaArrowsAltH,
  FaExchangeAlt,
  FaArrowsAltV,
} from "react-icons/fa";
import {
  Button,
  ButtonGroup,
  Divider,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import TldrInputWithAddon from "./TldrInputWithAddon";

function CustomSizeProjectModal(props) {
  const [customHeight, setCustomHeight] = useState(640);
  const [customWidth, setCustomWidth] = useState(640);
  const [lockAspectRatio, setLockAspectRadio] = useState(false);
  const { t } = useTranslation(["studio", "common"]);
  function onWidthFocusOut(text) {
    if (lockAspectRatio) {
      setCustomHeight(text);
    }
    setCustomWidth(text);
  }

  function onHeigthFocusOut(text) {
    if (lockAspectRatio) {
      setCustomWidth(text);
    }
    setCustomHeight(text);
  }

  function onValuesInterchange() {
    setCustomHeight(customWidth);
    setCustomWidth(customHeight);
  }

  return (
    <>
      <Modal isOpen={true} onClose={props.onHide} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader p="4">
            {t("custom_size_art_modal.modal_title")}
          </ModalHeader>
          <ModalCloseButton />
          <Divider my="0" />
          <ModalBody p="4">
            <Text>{t("custom_size_art_modal.modal_body")}</Text>
            <Flex
            direction="row"
            align="center"
            mt={4}
            >
              <TldrInputWithAddon
                addonLeftChildren={<FaArrowsAltH />}
                value={customWidth}
                onChange={onWidthFocusOut}
                maxLength={4}
                placeholder="Width"
                maxW="98px"
              />

              <StyledCustomStoryActions onClick={() => onValuesInterchange()}>
                <FaExchangeAlt />
              </StyledCustomStoryActions>
              <TldrInputWithAddon
                addonLeftChildren={<FaArrowsAltV />}
                value={customHeight}
                onChange={onHeigthFocusOut}
                maxLength={4}
                placeholder="Height"
                maxW="98px"
              />
              <Text m={2}>px</Text>

              <StyledCustomStoryActions
                onClick={() => setLockAspectRadio(!lockAspectRatio)}
              >
                {!lockAspectRatio ? <FaUnlock /> : <FaLock />}
              </StyledCustomStoryActions>
            </Flex>
          </ModalBody>
          <Divider my="0" />
          <ModalFooter p="3">
            <ButtonGroup>
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  props.onHide();
                }}
                color="primary"
                variant="secondary"
              >
                {t("cancel", { ns: "common" })}
              </Button>
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  props.onYes(
                    Number.parseInt(customWidth),
                    Number.parseInt(customHeight)
                  );
                }}
                colorScheme="primary"
                variant="solid"
              >
                {props?.okButton ?? t("custom_size_art_modal.modal_create_btn")}
              </Button>
            </ButtonGroup>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

CustomSizeProjectModal.propTypes = {
  onYes: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
};

export default CustomSizeProjectModal;
